import { EuiEnvConfig } from '@eui/core';

export const environment: EuiEnvConfig = {
    production: true,
    enableDevToolRedux: false,
    envDynamicConfig: {
        uri: 'assets/openid-login-config.json',
        deepMerge: true,
        merge: ['modules'],
    },
};
